import { Skeleton } from "@/shared/ui";

export default function FilterSkeleton() {
  return (
    <div className="w-72 shrink-0 flex flex-col gap-5">
      <Skeleton height={40} width="100%" />
      {Array.from({ length: 4 }, (_, i) => (
        <div key={i} className="flex flex-col gap-2.5">
          <Skeleton height={16} width={80} />
          {Array.from({ length: 3 }, (_, j) => (
            <Skeleton key={j} height={20} width="90%" />
          ))}
        </div>
      ))}
    </div>
  );
}
